module.exports = __webpack_public_path__ + "static/media/line-chart.49ea72fa.svg";